import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import signup from "../../assets/images/team/refer.png";
import profile from "../../assets/images/Home/profile.png";
import apply from "../../assets/images/Home/reward.png";
import arrow from "../../assets/images/Home/arrowup.png";
import axios from "axios";
import DOMPurify from "dompurify";

function Refer() {
  const [otp, setOtp] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    email: "",
  });
  const [referList, setReferlist] = useState([]);
  console.log("referlist", referList);
  const [baseurl, setBaseurl] = useState([]);

  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  const handleReferClick = () => {
    const user_id = localStorage.getItem("user_id"); // Move it here!

    // if (!user_id) {
    //   navigate("/login");
    // } else {
    navigate("/dashboard#refer");
    // }
  };
  useEffect(() => {
    fetchrefer();
  }, []);

  const fetchrefer = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/referral-cantent-list`
      );
      setReferlist(res.data.data || []);
      setBaseurl(res.data.imagePath || "");
      // setstatus(res.data.status);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    }
  };

  return (
    <section className="Refer">
      <Container>
        <div className="page_header"></div>
        {referList.length > 0 && (
          <div className="referral-content-section">
            {referList.map((item) => (
              <div className="referral-banner-section">
                <div className="banner-row">
                  <div className="banner-content">
                    <h2 className="banner-heading">{item.title}</h2>
                    {/* <p className="banner-subheading">{item.description}</p> */}
                    <p
                      className="mb-4p desc"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item?.description || ""),
                      }}
                    />
                    <div className="banner-btn-wrapper">
                      <button
                        className="btn-orange educate-btn"
                        onClick={handleReferClick}
                      >
                        <span className="educate-btn__curve" />
                        Refer Now
                      </button>
                    </div>
                  </div>
                  <div className="banner-image-large">
                    {item.image && (
                      <img
                        src={`${baseurl}${item.image.replace(/\\/g, "/")}`}
                        alt={item.title}
                        className="referral-image"
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>

      <div className="referral-form-section py-60" id="formReferral">
        <Container>
          <div className="steps-container">
            <div className="sec-title">
              <h6 class="color-primary mb-8">–––– Refer And Earn</h6>
              <h2 className="title mb-4">3 Easy Step to Earn Rewards</h2>
            </div>
            <div className="steps">
              {/* Step 1 */}
              <Link to={"/dashboard"} className="step step1">
                <div className="icon">
                  <img src={signup} alt="signup" />
                </div>
                <p>Refer</p>
              </Link>

              <div className="arrow">
                <img src={arrow} alt="arrow" />
              </div>

              {/* Step 2 */}
              <Link to={"/dashboard"} className="step step2">
                <div className="icon">
                  <img src={profile} alt="Complete Profile" />
                </div>
                <p>Join Friend</p>
              </Link>

              <div className="arrow arrowDown">
                <img src={arrow} alt="arrow" />
              </div>

              {/* Step 3 */}
              <Link to={"/dashboard"} className="step step3">
                <div className="icon">
                  <img src={apply} alt="Apply" />
                </div>
                <p>Earn Reward</p>
              </Link>
            </div>
          </div>
          <div className="banner-container">
            <div className="referral-row">
              <div className="benefits">
                <h3 className="benefits-heading">How It Works</h3>

                <Row className="gy-3">
                  <Col md="4">
                    <div className="benefit-item card h-100 shadow_light">
                      <div className="card-body">
                        <div className="benefit-icon">Step 1</div>
                        <div className="benefit-text">
                          <h4>Refer a Friend</h4>
                          <p>
                            {" "}
                            Simply share your unique referral link with your
                            friends, family, or colleagues who are interested in
                            law coaching.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="benefit-item card h-100 shadow_light">
                      <div className="card-body">
                        <div className="benefit-icon">Step 2</div>
                        <div className="benefit-text">
                          <h4> They Join The Excellers</h4>
                          <p>
                            {" "}
                            When someone you refer registers for a course at The
                            Excellers, using your referral link, they’ll receive
                            special benefits, and you’ll get rewarded.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="benefit-item card h-100 shadow_light">
                      <div className="card-body">
                        <div className="benefit-icon">Step 3</div>
                        <div className="benefit-text">
                          <h4>Earn Rewards</h4>
                          <p>
                            {" "}
                            For every successful referral, you can earn [Reward
                            Details] (e.g., discounts, cash rewards, free
                            classes, or exclusive access to materials).
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* <div className="referral-form col-md-5">
                <form className="form-container" onSubmit={handleSubmit}>
                  <h4 className="form-heading">Refer a Friend</h4>

                  <label htmlFor="fullName">Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    id="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Enter Full Name"
                    required
                  />

                  <label htmlFor="mobile">Mobile Number</label>
                  <input
                    type="tel"
                    name="mobile"
                    id="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Enter Mobile Number"
                    required
                  />

                  <label htmlFor="email">Email ID</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Email ID"
                    required
                  />
                  <label htmlFor="email">Password</label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter Password"
                    required
                  />
                  <label htmlFor="email">Refer Code</label>
                  <input
                    type="text"
                    name="refer_by"
                    id="refer_by"
                    value={formData.refer_by}
                    onChange={handleChange}
                    placeholder="Enter Refer"
                    required
                  />
                  <button type="submit" className="submit-btn educate-btn">
                    <span className="educate-btn__curve" />
                    Submit
                  </button>
                </form>
              </div> */}
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}

export default Refer;
